import {
  unredeemedpawn_overall,
  unredeemedpawn_cluster,
  unredeemedpawn_area,
  unredeemedpawn_branch,
} from "../../services/reports/unredeemedpawn_service";
import { actionTypes } from "../action_types";

const defaultUnredeemedPawn = {
  newPawnSummaries: {
    totalPieces: 0,
    totalPrincipal: 0,
  },
  pastDueSummaries: {
    totalPieces: 0,
    totalPrincipal: 0,
  },
  overDueSummaries: {
    totalPieces: 0,
    totalPrincipal: 0,
  },
  longOverDueSummaries: {
    totalPieces: 0,
    totalPrincipal: 0,
  },
};

const createUnredeemedPawnAction = (fetchFunction, actionType) => (data) => (dispatch) => {
  return fetchFunction(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionType,
        payload: resp.data !== null ? resp.data : defaultUnredeemedPawn,
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetUnredeemedPawnOverall = createUnredeemedPawnAction(
  unredeemedpawn_overall,
  actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_OVERALL
);

export const GetUnredeemedPawnCluster = createUnredeemedPawnAction(
  unredeemedpawn_cluster,
  actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_CLUSTER
);

export const GetUnredeemedPawnArea = createUnredeemedPawnAction(
  unredeemedpawn_area,
  actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_AREA
);

export const GetUnredeemedPawnBranch = createUnredeemedPawnAction(
  unredeemedpawn_branch,
  actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_BRANCH
);
